import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import BranchSelector from './BranchSelector';

const API_URL = '/api';
/*
const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http')) return imagePath;
  if (imagePath.startsWith('data:')) return imagePath;
  if (imagePath.startsWith('blob:')) return imagePath;

  // Remove any double slashes or duplicate uploads
  let cleanPath = imagePath;
  if (cleanPath.startsWith('/uploads/uploads/')) {
    cleanPath = cleanPath.replace('/uploads/uploads/', '/uploads/');
  }
  if (!cleanPath.startsWith('/uploads/') && !cleanPath.startsWith('uploads/')) {
    cleanPath = `/uploads/${cleanPath}`;
  }
  if (!cleanPath.startsWith('/')) {
    cleanPath = `/${cleanPath}`;
  }

  // ✅ Check if we're in development or production
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return `http://localhost:5000${cleanPath}`;
  } else {
    // In production, use the same domain (Apache will proxy to backend)
    return cleanPath;
  }
};
*/

const getImageUrl = (imagePath) => {
  if (!imagePath) return null;

  // If it's already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  if (imagePath.startsWith('data:')) return imagePath;
  if (imagePath.startsWith('blob:')) return imagePath;

  // Clean the path - ensure it starts with /uploads/
  let cleanPath = imagePath;

  // Remove any duplicate uploads
  if (cleanPath.includes('/uploads/uploads/')) {
    cleanPath = cleanPath.replace('/uploads/uploads/', '/uploads/');
  }

  // If it's just a filename (no slashes), add /uploads/
  if (!cleanPath.includes('/') && !cleanPath.startsWith('uploads')) {
    cleanPath = `/uploads/${cleanPath}`;
  }
  // If it starts with 'uploads/' (no leading slash), add it
  else if (cleanPath.startsWith('uploads/')) {
    cleanPath = `/${cleanPath}`;
  }
  // If it doesn't start with /uploads/, add it
  else if (!cleanPath.startsWith('/uploads/')) {
    cleanPath = `/uploads/${cleanPath}`;
  }

  // In development, use localhost:5000
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return `http://localhost:5000${cleanPath}`;
  } else {
    // ✅ FIX: In production, just return the clean path
    // The Apache proxy will handle /uploads -> backend
//return `https://invictustec.co.in${cleanPath}`;
return cleanPath;  
}
};


const ITEMS_PER_PAGE = 5;

function MultiBranchSelector({ branches, selectedBranchIds, onToggleBranch }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: '6px 12px',
          background: 'white',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          fontSize: '12px',
          fontWeight: '500',
          color: '#1e293b',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}
      >
        <span>🏪</span>
        <span>{selectedBranchIds.length === 0 ? 'Select Branches' : `${selectedBranchIds.length} Selected`}</span>
        <span style={{ fontSize: '10px', color: '#94a3b8' }}>▼</span>
      </button>

      {isOpen && (
        <div style={{
          position: 'absolute',
          top: 'calc(100% + 4px)',
          left: 0,
          width: '200px',
          background: 'white',
          border: '1px solid #e2e8f0',
          borderRadius: '10px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          zIndex: 1000,
          overflow: 'hidden'
        }}>
          <div style={{ padding: '6px 10px', borderBottom: '1px solid #f1f5f9', display: 'flex', gap: '6px', background: '#f8fafc' }}>
            <button onClick={() => onToggleBranch('all')} style={{ padding: '3px 10px', fontSize: '10px', background: '#f1f5f9', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>All</button>
            <button onClick={() => onToggleBranch('clear')} style={{ padding: '3px 10px', fontSize: '10px', background: '#fee2e2', border: 'none', borderRadius: '5px', cursor: 'pointer', color: '#ef4444' }}>Clear</button>
          </div>
          {branches.map(branch => (
            <div
              key={branch.id}
              onClick={() => onToggleBranch(branch.id)}
              style={{
                padding: '8px 10px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                background: selectedBranchIds.includes(branch.id) ? '#f0fdf4' : 'white',
                borderBottom: '1px solid #f8fafc'
              }}
            >
              <input type="checkbox" checked={selectedBranchIds.includes(branch.id)} readOnly style={{ width: '14px', height: '14px', margin: 0 }} />
              <span style={{ fontSize: '12px', fontWeight: '500' }}>{branch.branch_name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function BranchStockRow({ branches, selectedBranchIds, branchStocks, onStockChange }) {
  if (selectedBranchIds.length === 0) return null;

  return (
    <div style={{ marginBottom: '16px' }}>
      <div style={{ fontSize: '12px', fontWeight: '600', color: '#475569', marginBottom: '8px' }}>📦 Branch Stock</div>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        {selectedBranchIds.map(branchId => {
          const branch = branches.find(b => b.id === branchId);
          const stock = branchStocks[branchId] || { stock_quantity: 0 };
          return (
            <div key={branchId} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              background: '#f8fafc',
              padding: '6px 12px',
              borderRadius: '8px',
              border: '1px solid #e2e8f0'
            }}>
              <span style={{ fontSize: '12px', fontWeight: '600', color: '#1e293b' }}>{branch?.branch_name}</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ fontSize: '10px', color: '#64748b' }}>Stock:</span>
                <input
                  type="number"
                  min="0"
                  value={stock.stock_quantity === 0 ? '' : stock.stock_quantity}
                  onChange={(e) => {
                    const value = e.target.value === '' ? 0 : parseInt(e.target.value) || 0;
                    onStockChange(branchId, 'stock_quantity', value);
                  }}
                  placeholder="0"
                  style={{
                    width: '70px',
                    padding: '4px 8px',
                    fontSize: '12px',
                    border: '1px solid #cbd5e1',
                    borderRadius: '6px',
                    textAlign: 'center',
                    outline: 'none'
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function CustomSortDropdown({ sortBy, onSortChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const sortOptions = [
    { value: 'name', label: 'Name A-Z', icon: '🔤' },
    { value: 'nameDesc', label: 'Name Z-A', icon: '🔤' },
    { value: 'priceAsc', label: 'Price: Low to High', icon: '💰' },
    { value: 'priceDesc', label: 'Price: High to Low', icon: '💰' },
    { value: 'stockAsc', label: 'Stock: Low to High', icon: '📦' },
    { value: 'stockDesc', label: 'Stock: High to Low', icon: '📦' }
  ];

  const getSelectedLabel = () => {
    const option = sortOptions.find(opt => opt.value === sortBy);
    return option ? option.label : 'Sort';
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} style={{ position: 'relative' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: '6px 12px',
          background: 'white',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          fontSize: '12px',
          fontWeight: '500',
          color: '#1e293b',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}
      >
        <span>📊</span>
        <span>{getSelectedLabel()}</span>
        <span style={{ fontSize: '10px', color: '#94a3b8' }}>▼</span>
      </button>

      {isOpen && (
        <div style={{
          position: 'absolute',
          top: 'calc(100% + 4px)',
          right: 0,
          minWidth: '160px',
          background: 'white',
          border: '1px solid #e2e8f0',
          borderRadius: '10px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          zIndex: 1000,
          overflow: 'hidden'
        }}>
          {sortOptions.map((option) => (
            <div
              key={option.value}
              onClick={() => { onSortChange(option.value); setIsOpen(false); }}
              style={{
                padding: '8px 12px',
                cursor: 'pointer',
                fontSize: '11px',
                fontWeight: '500',
                background: sortBy === option.value ? '#f1f5f9' : 'white',
                color: sortBy === option.value ? '#0f172a' : '#475569',
                borderBottom: '1px solid #f1f5f9'
              }}
            >
              {option.icon} {option.label}
              {sortBy === option.value && <span style={{ float: 'right', color: '#10b981' }}>✓</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Inventory() {
  const [plants, setPlants] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [selectedCategoryFilter, setSelectedCategoryFilter] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('name');
  const [newCategoryName, setNewCategoryName] = useState('');
  const [showCatModal, setShowCatModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedBranchIds, setSelectedBranchIds] = useState([]);
  const [branchStocks, setBranchStocks] = useState({});

  const [formData, setFormData] = useState({
    sku: '', name: '', botanicalName: '', category: '',
    potSize: '6-inch', costPrice: '', retailPrice: '',
    wholesalePrice: '', wholesaleMinQty: '10', vatRate: '5',
    rackLocation: '', sunlight: 'Full Sun',
    plantHeight: '', plantAge: '', wateringSchedule: '', existingImageUrl: null,
  isWebsiteProduct: 'no'  // <--- ADD THIS LINE (default is 'no')
	
  });
// Add this useEffect after your other useEffects (around line 180-190)

useEffect(() => {
  // Register global function to close form from sidebar
  window.closeInventoryForm = () => {
    if (showForm) {
      resetForm();
    }
  };

  return () => {
    delete window.closeInventoryForm;
  };
}, [showForm]); // showForm changes apo register again pannum
  useEffect(() => { fetchBranches(); }, []);
  useEffect(() => { if (selectedBranch) initializeApp(); }, [selectedBranch]);
  useEffect(() => { initializeApp(); }, []);
  useEffect(() => { setCurrentPage(1); }, [selectedCategoryFilter, searchQuery, selectedBranch, sortBy]);

  const fetchBranches = async () => {
    try {
      const response = await axios.get(`${API_URL}/branches`);
      setBranches(response.data);
      if (response.data.length > 0) {
        const savedBranchId = localStorage.getItem('plantMasterBranchId');
        const dubaiBranch = response.data.find(b => b.branch_code === 'DXB01' || b.branch_name.toUpperCase().includes('DUBAI'));
        const defaultBranch = savedBranchId ? response.data.find(b => b.id === parseInt(savedBranchId)) || dubaiBranch || response.data[0] : dubaiBranch || response.data[0];
        setSelectedBranch(defaultBranch);
        if (dubaiBranch) {
          setSelectedBranchIds([dubaiBranch.id]);
          setBranchStocks({ [dubaiBranch.id]: { stock_quantity: 0 } });
        }
      }
    } catch (error) {
      const defaultBranches = [
        { id: 1, branch_code: 'SHJ01', branch_name: 'SHARJAH' },
        { id: 2, branch_code: 'DXB01', branch_name: 'DUBAI' }
      ];
      setBranches(defaultBranches);
      const dubaiBranch = defaultBranches.find(b => b.branch_code === 'DXB01');
      setSelectedBranch(dubaiBranch);
      if (dubaiBranch) {
        setSelectedBranchIds([dubaiBranch.id]);
        setBranchStocks({ [dubaiBranch.id]: { stock_quantity: 0 } });
      }
    }
  };

  const initializeApp = async () => {
    try {
      setLoading(true);
      const plantsRes = selectedBranch ? await axios.get(`${API_URL}/plants`, { headers: { 'x-branch-id': selectedBranch.id } }) : await axios.get(`${API_URL}/plants`);
      setPlants(plantsRes.data);
      const catRes = await axios.get(`${API_URL}/categories`);
      setCategories(catRes.data.map(cat => ({ id: cat.id, name: cat.cat_name })));
    } catch (error) { console.error('Init error:', error); } finally { setLoading(false); }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;



    setFormData({ ...formData, [name]: value });
  };

  const handleStockChange = (branchId, field, value) => {
    setBranchStocks(prev => ({ ...prev, [branchId]: { ...prev[branchId], [field]: value } }));
  };

  const handleAddCategory = async () => {
    if (!newCategoryName.trim()) return;
    try {
      const response = await axios.post(`${API_URL}/categories`, { name: newCategoryName.trim() });
      const newCat = { id: response.data.id, name: response.data.cat_name || response.data.name };
      setCategories(prev => [...prev, newCat]);
      setFormData(prev => ({ ...prev, category: newCategoryName.trim() }));
      setNewCategoryName('');
      setShowCatModal(false);
      initializeApp();
    } catch (err) {
      setCategories(prev => [...prev, { id: Date.now(), name: newCategoryName.trim() }]);
      setFormData(prev => ({ ...prev, category: newCategoryName.trim() }));
      setNewCategoryName('');
      setShowCatModal(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const toggleBranch = (branchId) => {
    if (branchId === 'all') {
      setSelectedBranchIds(branches.map(b => b.id));
      const newStocks = {};
      branches.forEach(b => { newStocks[b.id] = { stock_quantity: 0 }; });
      setBranchStocks(newStocks);
    } else if (branchId === 'clear') {
      setSelectedBranchIds([]);
      setBranchStocks({});
    } else {
      setSelectedBranchIds(prev => prev.includes(branchId) ? prev.filter(id => id !== branchId) : [...prev, branchId]);
      if (!branchStocks[branchId]) setBranchStocks(prev => ({ ...prev, [branchId]: { stock_quantity: 0 } }));
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.retailPrice) {
      alert("Please fill Name and Retail Price");
      return;
    }
    if (selectedBranchIds.length === 0) {
      alert("Please select at least one branch");
      return;
    }

    for (const branchId of selectedBranchIds) {
      const stockValue = branchStocks[branchId]?.stock_quantity;
      if (stockValue === undefined || stockValue === null || stockValue === '') {
        alert(`Please set stock quantity for ${branches.find(b => b.id === branchId)?.branch_name}`);
        return;
      }
    }

    try {
      const submitData = new FormData();

      /*Object.keys(formData).forEach(key => {
        if (formData[key] !== '' && formData[key] !== null && formData[key] !== undefined) {
          if (key === 'name') submitData.append(key, formData[key].toUpperCase());
          else if (key === 'existingImageUrl' && formData[key]) submitData.append('existingImageUrl', formData[key]);
          else submitData.append(key, formData[key]);
        }
      });*/

Object.keys(formData).forEach(key => {
  if (formData[key] !== '' && formData[key] !== null && formData[key] !== undefined) {
    if (key === 'name') {
      submitData.append(key, formData[key].toUpperCase());
    } else if (key === 'existingImageUrl' && formData[key]) {
      submitData.append('existingImageUrl', formData[key]);
    } else if (key === 'isWebsiteProduct') {
      // Convert 'yes' to true, 'no' to false for backend
      submitData.append(key, formData[key] === 'yes' ? 'true' : 'false');
    } else {
      submitData.append(key, formData[key]);
    }
  }
});
      if (imageFile) submitData.append('image', imageFile);
      submitData.append('branch_ids', JSON.stringify(selectedBranchIds));

      const branchStockData = selectedBranchIds.map(branchId => ({
        branch_id: branchId,
        stock_quantity: parseInt(branchStocks[branchId]?.stock_quantity) || 0
      }));
      submitData.append('branch_stocks', JSON.stringify(branchStockData));

      if (editingId) {
        await axios.put(`${API_URL}/plants/multi-branch/${editingId}`, submitData);
      } else {
        await axios.post(`${API_URL}/plants/multi-branch`, submitData);
      }
      resetForm();
      initializeApp();
    } catch (error) {
      console.error('Submission error:', error);
      alert('Error saving product');
    }
  };

  const editPlant = async (plant) => {
    setEditingId(plant.id);
    setShowForm(true);

    setFormData({
      sku: plant.sku || '',
      name: plant.name,
      botanicalName: plant.botanical_name || '',
      category: plant.category || categories[0]?.name,
      potSize: plant.pot_size || '6-inch',
      costPrice: plant.cost_price || '',
      retailPrice: plant.retail_price,
      wholesalePrice: plant.wholesale_price || '',
      wholesaleMinQty: plant.wholesale_min_qty || '10',
      vatRate: plant.vat_rate || '5',
      rackLocation: plant.rack_location || '',
      sunlight: plant.sunlight || 'Full Sun',
      plantHeight: plant.plant_height || '',
      plantAge: plant.plant_age || '',
      wateringSchedule: plant.watering_schedule || '',
      existingImageUrl: plant.image_url || null,
    isWebsiteProduct: plant.is_website_product ? 'yes' : 'no'  // <--- ADD THIS LINE

    });

    setImagePreview(plant.image_url || '');
    setImageFile(null);

    try {
      const stockRes = await axios.get(`${API_URL}/plants/${plant.id}/branch-stock`);
      const stockMap = {};
      stockRes.data.forEach(item => {
        stockMap[item.branch_id] = { stock_quantity: item.stock_quantity };
      });
      setBranchStocks(stockMap);
      setSelectedBranchIds(stockRes.data.map(item => item.branch_id));
    } catch (error) {
      console.error('Error fetching stock:', error);
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const deletePlant = async (id, name) => {
    if (window.confirm(`Delete "${name}" permanently?`)) {
      try { await axios.delete(`${API_URL}/plants/${id}`); initializeApp(); }
      catch (error) { alert('Deletion failed'); }
    }
  };

  const resetForm = () => {
    setEditingId(null);
    setShowForm(false);
    const dubaiBranch = branches.find(b => b.branch_code === 'DXB01' || b.branch_name.toUpperCase().includes('DUBAI'));
    const defaultBranchIds = dubaiBranch ? [dubaiBranch.id] : (branches.length > 0 ? [branches[0].id] : []);
    setSelectedBranchIds(defaultBranchIds);

    const initialStocks = {};
    defaultBranchIds.forEach(id => { initialStocks[id] = { stock_quantity: 0 }; });
    setBranchStocks(initialStocks);

    setFormData({
      sku: '', name: '', botanicalName: '', category: categories[0]?.name || '',
      potSize: '6-inch', costPrice: '', retailPrice: '', wholesalePrice: '',
      wholesaleMinQty: '10', vatRate: '5', rackLocation: '', sunlight: 'Full Sun',
      plantHeight: '', plantAge: '', wateringSchedule: '', existingImageUrl: null,    isWebsiteProduct: 'no'  // <--- ADD THIS LINE

    });
    setImageFile(null);
    setImagePreview('');
  };

  const getSortedPlants = (plantsToSort) => {
    const sorted = [...plantsToSort];
    switch (sortBy) {
      case 'name': return sorted.sort((a, b) => a.name?.localeCompare(b.name));
      case 'nameDesc': return sorted.sort((a, b) => b.name?.localeCompare(a.name));
      case 'priceAsc': return sorted.sort((a, b) => parseFloat(a.retail_price) - parseFloat(b.retail_price));
      case 'priceDesc': return sorted.sort((a, b) => parseFloat(b.retail_price) - parseFloat(a.retail_price));
      case 'stockAsc': return sorted.sort((a, b) => parseInt(a.stock) - parseInt(b.stock));
      case 'stockDesc': return sorted.sort((a, b) => parseInt(b.stock) - parseInt(a.stock));
      default: return sorted;
    }
  };

  const filteredPlants = plants.filter(plant => {
    const matchesCategory = selectedCategoryFilter === 'All' || plant.category === selectedCategoryFilter;
    const matchesSearch = plant.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         (plant.sku && plant.sku.toLowerCase().includes(searchQuery.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  const sortedPlants = getSortedPlants(filteredPlants);
  const totalPages = Math.ceil(sortedPlants.length / ITEMS_PER_PAGE);
  const currentItems = sortedPlants.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>🌱 Loading...</div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '16px', fontFamily: 'system-ui, -apple-system, sans-serif', background: '#f8fafc', minHeight: '100vh' }}>

      {/* Header */}
      <div style={{ marginBottom: '16px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#0f172a', margin: 0 }}>Inventory</h1>
      </div>

      {/* Category Modal */}
      {showCatModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: '12px', padding: '20px', width: '90%', maxWidth: '350px' }}>
            <h3 style={{ margin: '0 0 12px 0', fontSize: '16px', fontWeight: '600' }}>Add Category</h3>
            <input
              type="text"
              placeholder="Category name"
              value={newCategoryName}
              onChange={(e) => setNewCategoryName(e.target.value)}
              style={{ width: '100%', padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' }}
              autoFocus
            />
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowCatModal(false)} style={{ padding: '6px 16px', background: '#f1f5f9', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Cancel</button>
              <button onClick={handleAddCategory} style={{ padding: '6px 16px', background: '#0f172a', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Add</button>
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Form */}
      {showForm && (
        <div style={{ background: 'white', borderRadius: '12px', marginBottom: '20px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h2 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>{editingId ? 'Edit Product' : 'Add New Product'}</h2>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button type="submit" form="plantForm" style={{ padding: '6px 16px', background: '#0f172a', color: 'white', border: 'none', borderRadius: '6px', fontWeight: '500', cursor: 'pointer', fontSize: '12px' }}>Save</button>
              <button onClick={resetForm} style={{ padding: '6px 16px', background: '#f1f5f9', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Cancel</button>
            </div>
          </div>

          <div style={{ padding: '16px' }}>
            {/* Branch Selection */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px', padding: '8px 12px', background: '#f8fafc', borderRadius: '8px' }}>
              <span style={{ fontSize: '12px', fontWeight: '500', color: '#475569' }}>Select Branches:</span>
              <MultiBranchSelector branches={branches} selectedBranchIds={selectedBranchIds} onToggleBranch={toggleBranch} />
              {selectedBranchIds.length > 0 && (
                <span style={{ fontSize: '11px', background: '#e2e8f0', padding: '2px 8px', borderRadius: '12px', color: '#475569' }}>
                  {selectedBranchIds.length} selected
                </span>
              )}
            </div>

            {/* Branch Stock */}
            <BranchStockRow branches={branches} selectedBranchIds={selectedBranchIds} branchStocks={branchStocks} onStockChange={handleStockChange} />

            <form onSubmit={handleFormSubmit} id="plantForm">
              {/* Product Details */}
              <div style={{ marginBottom: '16px' }}>
                <h3 style={{ fontSize: '13px', fontWeight: '600', color: '#0f172a', marginBottom: '10px' }}>Product Details</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>SKU</label>
                    <input type="text" name="sku" value={formData.sku} onChange={handleInputChange} placeholder="Auto" style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>Item Name *</label>
                    <input type="text" name="name" value={formData.name} onChange={handleInputChange} required style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>Botanical Name</label>
                    <input type="text" name="botanicalName" value={formData.botanicalName} onChange={handleInputChange} style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px' }} />
                  </div>
                  <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                      <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569' }}>Category *</label>
                      <button type="button" onClick={() => setShowCatModal(true)} style={{ fontSize: '10px', color: '#10b981', background: 'none', border: 'none', cursor: 'pointer' }}>+ New</button>
                    </div>
                    <select name="category" value={formData.category} onChange={handleInputChange} style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px', background: 'white' }} required>
                      {categories.map(cat => <option key={cat.id} value={cat.name}>{cat.name}</option>)}
                    </select>
                  </div>
                </div>
              </div>

              {/* Plant Attributes */}
              <div style={{ marginBottom: '16px' }}>
                <h3 style={{ fontSize: '13px', fontWeight: '600', color: '#0f172a', marginBottom: '10px' }}>Plant Attributes</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>Height</label>
                    <input type="text" name="plantHeight" value={formData.plantHeight} onChange={handleInputChange} placeholder="e.g., 2.5 Feet" style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>Age</label>
                    <input type="text" name="plantAge" value={formData.plantAge} onChange={handleInputChange} placeholder="e.g., 8 Weeks" style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>Watering</label>
                    <select name="wateringSchedule" value={formData.wateringSchedule} onChange={handleInputChange} style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px', background: 'white' }}>
                      <option value="">Select</option>
                      <option value="Daily">Daily</option>
                      <option value="Alternate Days">Every 2 Days</option>
                      <option value="Twice a Week">Twice Weekly</option>
                      <option value="Weekly">Weekly</option>
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>Sunlight</label>
                    <select name="sunlight" value={formData.sunlight} onChange={handleInputChange} style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px', background: 'white' }}>
                      <option value="Full Sun">Full Sun</option>
                      <option value="Partial Sun">Partial Sun</option>
                      <option value="Shade">Shade</option>
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>Pot Size</label>
                    <select name="potSize" value={formData.potSize} onChange={handleInputChange} style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px', background: 'white' }}>
                      <option value="4-inch">4-inch</option>
                      <option value="6-inch">6-inch</option>
                      <option value="8-inch">8-inch</option>
                      <option value="10-inch">10-inch</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Pricing */}
              <div style={{ marginBottom: '16px' }}>
                <h3 style={{ fontSize: '13px', fontWeight: '600', color: '#0f172a', marginBottom: '10px' }}>Pricing & Location</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>Base Price (AED)</label>
                    <input type="number" step="0.01" name="costPrice" value={formData.costPrice} onChange={handleInputChange} style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>Retail Price *</label>
                    <input type="number" step="0.01" name="retailPrice" value={formData.retailPrice} onChange={handleInputChange} required style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>VAT (%)</label>
                    <input type="number" step="0.01" name="vatRate" value={formData.vatRate} onChange={handleInputChange} style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px' }} />
                  </div>

 <div>
      <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>Website Product</label>  {/* <--- NEW FIELD */}
      <select 
        name="isWebsiteProduct" 
        value={formData.isWebsiteProduct} 
        onChange={handleInputChange} 
        style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px', background: 'white' }}
      >
        <option value="no">No</option>
        <option value="yes">Yes</option>
      </select>
    </div>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#475569', display: 'block', marginBottom: '4px' }}>Rack Location</label>
                    <input type="text" name="rackLocation" value={formData.rackLocation} onChange={handleInputChange} style={{ width: '100%', padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px' }} />
                  </div>
                </div>
              </div>

              {/* Image Upload */}
              <div>
                <h3 style={{ fontSize: '13px', fontWeight: '600', color: '#0f172a', marginBottom: '10px' }}>Product Image</h3>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px', background: '#f8fafc', borderRadius: '8px' }}>
                  <input type="file" accept="image/*" onChange={handleImageChange} style={{ fontSize: '12px' }} />
                  {imagePreview && <img src={getImageUrl(imagePreview)} alt="Preview" style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '6px' }} />}
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Main View */}
      {!showForm && (
        <>
          {/* Toolbar */}
          <div style={{ background: 'white', borderRadius: '12px', padding: '12px 16px', marginBottom: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '12px' }}>
              <div style={{ flex: 1, minWidth: '200px' }}>
                <div style={{ position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '12px' }}>🔍</span>
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ width: '100%', padding: '6px 10px 6px 30px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '12px', outline: 'none' }}
                  />
                </div>
              </div>

              <BranchSelector
                currentBranch={selectedBranch}
                onBranchChange={(branch) => {
                  setSelectedBranch(branch);
                  localStorage.setItem('plantMasterBranchId', branch.id);
                  setCurrentPage(1);
                }}
                branches={branches}
              />

              <CustomSortDropdown sortBy={sortBy} onSortChange={setSortBy} />

              <button onClick={() => { resetForm(); setShowForm(true); }} style={{ padding: '6px 16px', background: '#0f172a', color: 'white', border: 'none', borderRadius: '8px', fontWeight: '500', cursor: 'pointer', fontSize: '12px' }}>
                + Add
              </button>
            </div>

            {/* Category Chips */}
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', borderTop: '1px solid #f1f5f9', paddingTop: '10px' }}>
              <button
                onClick={() => setSelectedCategoryFilter('All')}
                style={{
                  padding: '4px 12px',
                  background: selectedCategoryFilter === 'All' ? '#0f172a' : 'white',
                  color: selectedCategoryFilter === 'All' ? 'white' : '#475569',
                  border: selectedCategoryFilter === 'All' ? 'none' : '1px solid #e2e8f0',
                  borderRadius: '16px',
                  fontSize: '11px',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                All ({plants.length})
              </button>
              {categories.map(cat => {
                const count = plants.filter(p => p.category === cat.name).length;
                return (
                  <button
                    key={cat.id}
                    onClick={() => setSelectedCategoryFilter(cat.name)}
                    style={{
                      padding: '4px 12px',
                      background: selectedCategoryFilter === cat.name ? '#0f172a' : 'white',
                      color: selectedCategoryFilter === cat.name ? 'white' : '#475569',
                      border: selectedCategoryFilter === cat.name ? 'none' : '1px solid #e2e8f0',
                      borderRadius: '16px',
                      fontSize: '11px',
                      fontWeight: '500',
                      cursor: 'pointer'
                    }}
                  >
                    {cat.name} ({count})
                  </button>
                );
              })}
            </div>
          </div>

          {/* Products Table */}
          <div style={{ background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
            {sortedPlants.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <div style={{ fontSize: '40px', marginBottom: '8px' }}>🌿</div>
                <p style={{ color: '#64748b', fontSize: '13px' }}>No products found</p>
                <button onClick={() => { resetForm(); setShowForm(true); }} style={{ marginTop: '12px', padding: '6px 16px', background: '#0f172a', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px' }}>+ Add Item</button>
              </div>
            ) : (
              <>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>


<thead>
  <tr style={{ borderBottom: '1px solid #f1f5f9', background: '#fafbfc' }}>
    <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#64748b' }}>Item</th>
    <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#64748b' }}>Category</th>
    <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#64748b' }}>Price</th>
    <th style={{ padding: '10px 12px', textAlign: 'center', fontSize: '11px', fontWeight: '600', color: '#64748b' }}>Stock</th>
    <th style={{ padding: '10px 12px', textAlign: 'center', fontSize: '11px', fontWeight: '600', color: '#64748b' }}>Website</th>
    <th style={{ padding: '10px 12px', textAlign: 'center', fontSize: '11px', fontWeight: '600', color: '#64748b' }}>Actions</th>
  </tr>
</thead>




<tbody>
  {currentItems.map((plant) => (
    <tr key={plant.id} style={{ borderBottom: '1px solid #f8fafc' }}>
      {/* 1. ITEM */}
      <td style={{ padding: '10px 12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {plant.image_url ? (
            <img src={getImageUrl(plant.image_url)} style={{ width: '32px', height: '32px', objectFit: 'cover', borderRadius: '6px' }} alt={plant.name} />
          ) : (
            <div style={{ width: '32px', height: '32px', background: '#f1f5f9', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px' }}>🌱</div>
          )}
          <div>
            <div style={{ fontWeight: '600', fontSize: '12px', color: '#0f172a' }}>{plant.name?.toUpperCase()}</div>
            <div style={{ fontSize: '10px', color: '#94a3b8' }}>{plant.sku || 'No SKU'}</div>
          </div>
        </div>
      </td>

      {/* 2. CATEGORY */}
      <td style={{ padding: '10px 12px' }}>
        <span style={{ padding: '2px 10px', background: '#f1f5f9', borderRadius: '12px', fontSize: '10px', fontWeight: '500', color: '#475569' }}>
          {plant.category || 'Uncategorized'}
        </span>
      </td>

      {/* 3. PRICE */}
      <td style={{ padding: '10px 12px' }}>
        <div style={{ fontWeight: '600', fontSize: '12px', color: '#0f172a' }}>AED {plant.retail_price}</div>
        {plant.wholesale_price && <div style={{ fontSize: '10px', color: '#94a3b8' }}>Trade: AED {plant.wholesale_price}</div>}
      </td>

      {/* 4. STOCK */}
      <td style={{ padding: '10px 12px', textAlign: 'center' }}>
        <span style={{ fontWeight: '600', fontSize: '12px', color: plant.stock <= 5 ? '#ef4444' : '#10b981' }}>{plant.stock || 0}</span>
      </td>

      {/* 5. WEBSITE - THIS SHOULD BE HERE (between Stock and Actions) */}
      <td style={{ padding: '10px 12px', textAlign: 'center' }}>
        <span style={{
          padding: '2px 8px',
          borderRadius: '12px',
          fontSize: '10px',
          fontWeight: '600',
          background: plant.is_website_product ? '#d1fae5' : '#fef3c7',
          color: plant.is_website_product ? '#065f46' : '#92400e'
        }}>
          {plant.is_website_product ? 'Yes' : 'No'}
        </span>
      </td>

      {/* 6. ACTIONS */}
      <td style={{ padding: '10px 12px', textAlign: 'center' }}>
        <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
          <button onClick={() => editPlant(plant)} style={{ padding: '3px 10px', background: '#f1f5f9', border: 'none', borderRadius: '5px', fontSize: '10px', cursor: 'pointer' }}>Edit</button>
          <button onClick={() => deletePlant(plant.id, plant.name)} style={{ padding: '3px 10px', background: '#fee2e2', border: 'none', borderRadius: '5px', fontSize: '10px', color: '#ef4444', cursor: 'pointer' }}>Del</button>
        </div>
      </td>
    </tr>
  ))}
</tbody>                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div style={{ padding: '10px 12px', borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <button
                      onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                      disabled={currentPage === 1}
                      style={{ padding: '4px 12px', background: '#f1f5f9', border: 'none', borderRadius: '6px', fontSize: '11px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', opacity: currentPage === 1 ? 0.5 : 1 }}
                    >
                      ← Prev
                    </button>
                    <span style={{ fontSize: '11px', color: '#64748b' }}>{currentPage} / {totalPages}</span>
                    <button
                      onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      style={{ padding: '4px 12px', background: '#f1f5f9', border: 'none', borderRadius: '6px', fontSize: '11px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', opacity: currentPage === totalPages ? 0.5 : 1 }}
                    >
                      Next →
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default Inventory;
